import 'core-js/stable';
import 'regenerator-runtime/runtime';

import $ from 'jquery';

/**
 * DOMContentLoaded
 */
document.addEventListener('DOMContentLoaded', () => {
  // JavaScript to be fired on all pages
  $.ajax({
    url: '/columns/rss.xml',
    dataType: 'xml',
    success: function(data) {
      // NEWSページ
      var insertContents = '';
      $('item', data).each(function() {
        var thisItem = $(this);
        insertContents += '<article class="pickup">';
        insertContents += '<div class="pickup__container">';
        insertContents += '<header class="pickup__header">';
        insertContents += '<h3 class="pickup__title">';
        insertContents += '<span class="pickup__category">' + thisItem.children('category').text() + '</span>';
        insertContents += '<a href="' + thisItem.children('link').text() + '">';
        insertContents += thisItem.children('title').text();
        insertContents += '</a>';
        insertContents += '</h3>';
        insertContents += '<time class="pickup__date updated" datetime="' + thisItem.children('updated').text() + '">';
        insertContents += thisItem.children('time').text();
        insertContents += '</time>';
        insertContents += '<aside class="pickup__author">';
        insertContents += thisItem.children('summary').text();
        insertContents += '</aside>';
        insertContents += '<div class="pickup__btn">';
        insertContents += '<a href="' + thisItem.children('link').text() + '">';
        insertContents += '記事の内容を詳しく見る　>';
        insertContents += '</a>';
        insertContents += '</div>';
        insertContents += '</header>';
        insertContents += '</div>';
        if (thisItem.children('thumbnailUrl').text() !== '') {
          insertContents += '<figure class="pickup__thumbnail">';
          insertContents += '<a href="' + thisItem.children('link').text() + '">';
          insertContents +=
            '<img src="' +
            thisItem.children('thumbnailUrl').text() +
            '" alt="' +
            thisItem.children('title').text() +
            '" loading="lazy">';
          insertContents += '</a>';
          insertContents += '</figure>';
        }
        insertContents += '</article>';
      });
      $('.rss').append(insertContents);
    },
  });
});
